/**
 * The keyboard, in words: what each key does. One list, read by Settings'
 * Controls page and by the panel beside the board on a wide screen
 * (`GameFrame`'s `side`), so the two never disagree. The bindings themselves
 * are `input/keyboard.ts`'s; `test/game/game-parts.test.ts` checks the two
 * name the same actions.
 */
export interface KeyHint {
  readonly action: string;
  readonly keys: string;
}

/**
 * The keys by their names ("Left", "Up"), not as arrow glyphs: the house
 * face (Nunito, `@artibens/app-shell/fonts.css`) has no left or right
 * arrow, and a device would draw them in a face of its own.
 */
export const KEY_HINTS: readonly KeyHint[] = [
  { action: 'Move', keys: 'Left, Right' },
  { action: 'Soft drop', keys: 'Down' },
  { action: 'Hard drop', keys: 'Space' },
  { action: 'Rotate', keys: 'Up or X · Z or Ctrl the other way' },
  { action: 'Hold', keys: 'C or Shift' },
];
